import React, { useEffect, useState } from 'react';
import { useScrollReveal } from '~/hooks/useScrollReveal';
import styles from './SectionNavigation.module.scss';
import { PosthogHelper } from '~/helpers/PosthogHelper';
import { AnalyticsEventNames } from '~/tracking';

export const SectionNavigation = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';
    const [isActive, setIsActive] = useState('Mission');

    const handleClick = (id: string, itemName: string) => {
        PosthogHelper.captureEvent(AnalyticsEventNames.AnchorItem, { item: itemName });
        setIsActive(id);
    };

    useEffect(() => {
        const handleScroll = () => {
            // Iterate through your sections and find the one in the viewport
            const sections = ['Mission', 'Team', 'VinovestCouncil'];

            for (const sectionId of sections) {
                const sectionElement = document.querySelector(`#${sectionId}`);

                if (sectionElement) {
                    const rect = sectionElement.getBoundingClientRect();
                    if (rect.top <= 100 && rect.bottom >= 0) {
                        setIsActive(sectionId);
                        break;
                    }
                }
            }
        };

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className={styles.container} ref={ref}>
            <ul className={`${styles.menu} ${runAnimation}`}>
                <li>
                    <a
                        href={'#Mission'}
                        onClick={() => handleClick('Mission', 'mission')}
                        className={`${isActive === 'Mission' && 'active'}`}
                    >
                        Mission
                    </a>
                </li>
                <li>
                    <a
                        href={'#Team'}
                        onClick={() => handleClick('Team', 'team')}
                        className={`${isActive === 'Team' && 'active'}`}
                    >
                        Team
                    </a>
                </li>
                <li>
                    <a
                        href={'#VinovestCouncil'}
                        onClick={() => handleClick('VinovestCouncil', 'vinovestCouncil')}
                        className={`${isActive === 'VinovestCouncil' && 'active'}`}
                    >
                        Vinovest Council
                    </a>
                </li>
            </ul>
        </div>
    );
};
